import { CheckCircle } from 'lucide-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FadeLoader } from 'react-spinners';

import {
  setCurrentStep,
  setDifficultyLevel
} from '../../redux/Slices/InterviewSlice';
import { Language } from '../../redux/Slices/InterviewSlice/types';
import { setCurrentTab } from '../../redux/Slices/ResultsSlice/ResultsSlice';
import { useAppDispatch, useAppSelector } from '../../redux/store/hooks';
import { useInterviewEndTestMutation } from '../../services/interViewApi';

const InterviewComplete = ({
  setCurrentQuestionIndex,
  setSelectedLanguage,
  setShowTimer,
  setIsRecording,
  setIsPlayingAudio,
  setOverallTimer,
  loading,
  setIsLoading
}: {
  setCurrentQuestionIndex: (index: number) => void;
  setSelectedLanguage: (language: Language | null) => void;
  setShowTimer: (showTimer: boolean) => void;
  setIsRecording: (isRecording: boolean) => void;
  setIsPlayingAudio: (isPlayingAudio: boolean) => void;
  setOverallTimer: (overallTimer: number) => void;
  setIsLoading: (isLoading: boolean) => void;
  loading: boolean;
}) => {
  const dispatch = useAppDispatch();
  const [interviewEndTest] = useInterviewEndTestMutation();
  const { testData } = useAppSelector(state => state.root.interview);
  const navigate = useNavigate();
  const handleEndTest = async () => {
    setSelectedLanguage(null);
    setShowTimer(false);
    setIsRecording(false);
    setIsPlayingAudio(false);
    setOverallTimer(1800);
    try {
      await interviewEndTest(testData?.id);
      setIsLoading(false);
    } catch (err) {
      console.log(err, 'err');
      setIsLoading(false);
    }
  };
  const handleNavigate = (route: string) => {
    dispatch(setCurrentStep('language'));
    dispatch(setDifficultyLevel(''));
    setCurrentQuestionIndex(0);
    setSelectedLanguage(null);
    setShowTimer(false);
    setIsRecording(false);
    setIsPlayingAudio(false);
    setOverallTimer(1800);
    route && navigate('/results');
    dispatch(setCurrentTab('interview'));
  };
  useEffect(() => {
    if (testData?.id) {
      handleEndTest();
    }
  }, [testData]);

  return (
    <>
      {loading && (
        <div
          style={{ height: 'calc(-5rem + 100vh)' }}
          className='flex flex-col items-center justify-center p-8 text-center'
        >
          <h2 className='mb-2 text-xl font-semibold text-gray-800'>
            Saving Your Test...
          </h2>
          <p className='mb-6 max-w-md text-gray-600'>
            Please wait while your test is being saved. Do not refresh the page
            or perform any other Action.
          </p>
          <div>
            <FadeLoader
              color={'#36d7b7'}
              loading={loading}
              aria-label='Loading Spinner'
              data-testid='loader'
            />
          </div>
        </div>
      )}
      {!loading && (
        <div className='w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-2xl'>
          <div className='mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-green-500 to-blue-600'>
            <CheckCircle className='h-8 w-8 text-white' />
          </div>
          <h1 className='mb-4 text-3xl font-bold text-gray-800'>
            Interview Complete!
          </h1>
          <p className='mb-8 text-gray-600'>
            Thank you for completing the speaking interview. Your responses have
            been recorded successfully.
          </p>
          <button
            onClick={() => handleNavigate('')}
            className='w-full rounded-xl bg-gradient-to-r from-green-500 to-blue-600 px-6 py-3 font-semibold text-white shadow-lg transition-all duration-200 hover:from-green-600 hover:to-blue-700'
          >
            Start New Interview
          </button>
          <button
            onClick={() => handleNavigate('navigate')}
            className='mt-3 w-full rounded-xl bg-gradient-to-r from-green-500 to-blue-600 px-6 py-3 font-semibold text-white shadow-lg transition-all duration-200 hover:from-green-600 hover:to-blue-700'
          >
            View Results.
          </button>
        </div>
      )}
    </>
  );
};

export default InterviewComplete;
